import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";

/**
 * @description 康养藏品
 * @return {/culturalExchange_kangyang/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        setHasPermission(accessRes.data?.isPermission)
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = () => {
    if(!hasPermission){
      return;
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const toKangyang = () => {
    const uri = `${process.env.REACT_APP_GKT_LINK}/front/guapp/kangyang/kangyangju`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${uri}`,
      });
    } else {
      navigate(uri);
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.buyBtn} style={{ filter: hasPermission ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={!hasPermission}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {/* {data?.priFlag && <div className={Styles.textCount}>优先购最多可购买{data?.priNum || 0}个</div>} */}
      {/* <div className={Styles.textCount}>优先购最多可购买{data?.priNum || 0}个</div> */}

      <div className={Styles.centerCard}>
        {/* <div className={Styles.centerCardBox1}>
            <div className={Styles.context}>
              <div className={Styles.lefttem}>
                  <div className={Styles.leftItem1}>
                    欧皇徽章权益领取
                  </div>
              </div>
              <div className={Styles.rightItem}>
                  {!data?.hasBadgeFlag && <div className={Styles.leftItem2} style={{ filter: data?.badgeFlag ? '' : 'grayscale(1)'}} onClick={()=>handleToOrder(1)}></div>}
                  {data?.hasBadgeFlag &&<div className={Styles.leftItem3} onClick={()=>handleToOrder(2)}>查看详情></div>}
              </div>
            </div>
        </div> */}

        <div className={Styles.centerCardBox3}>
          <div className={Styles.title}>藏品权益</div>
          <div className={Styles.context}>
              <div className={Styles.rareItemsCard}>
                <div className={Styles.detailImg}>
                    <img src={require('@/assets/img/culturalExchange_kangyang/detailimg@2x.png')} alt="康养藏品" />
                </div>
                <div className={Styles.detailText}>
                    <div className={Styles.detailTextTitle}>绿地国际康养城-颐尚居8天7晚的入住权益预约权<br/>（预约热线：18964612029）</div>
                    <div className={Styles.detailTextContent}>
                      <div className={Styles.detailTextContentItem} onClick={toKangyang}></div>
                    </div>
                </div>
              </div>
            </div>
            <div className={Styles.rulebox}>
                <img src={require('@/assets/img/culturalExchange_kangyang/txtimg1.png')} alt="规则1" />
            </div>
          </div>

          <div className={Styles.rulebox2}>
            <img src={require('@/assets/img/culturalExchange_kangyang/txtimg2.png')} alt="规则2" />
          </div>

          <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>
      </div>
    </div>
  )
}
export default Home
